import React from 'react';
import { inject, observer } from 'mobx-react';
import styles from './index.module.scss';
import type { AppStore } from '@stores/app/store';
import type { SiteStore } from '@stores/site/store';
import type { UserAction } from '@stores/user/action';
import Avatar from '@components/avatar';
import { BASE_IMG_URL } from '@images/imageUrls';
import classNames from 'classnames';
import { formatTime } from '@utils/timeUtils'; // 相对路径
import InfiniteScrollList from '@components/InfiniteScrollList';
import { Image } from 'antd';
import updateImageListSrc from "@utils/update-image-list-src";
import parse, { domToReact } from 'html-react-parser';
interface PCSystemListProps {
    app?: AppStore;
    site?: SiteStore;
    user?: UserAction;
    loading?: boolean;
    hasMore?: boolean;
    onLoadMore?: () => void;
    data: any
    itemClick?: Function
    searchKeyword?: any // 需要高亮的关键字
    emptyText?: string; // 为空时提示文字
    emptyIcon?: string; // 为空时icon
    emptyBoxStyle?: any; // 为空状态时的自定义样式
}

@inject('app', 'site')
@observer
class PCSystemList extends React.Component<PCSystemListProps> {
    componentDidMount() {
        // 可以在这里添加初始化逻辑
    }

    // 渲染单个列表项
    renderItem = (item: any, index: number) => {
        const { itemClick } = this.props;
        // console.log(showRecommendUserList, '是否显示推荐关注列表', recommendUserList)
        let options = {};
        const parserOptions = {
            replace: (domNode: any) => {
                // 可以在这里自定义节点替换逻辑
            },
            ...options
        };
        return (
            <React.Fragment key={item.data.id || item.data._id || index}>
                <div className={styles.item} key={item.data.id || item.data._id} onClick={() => {
                    itemClick && itemClick(item)
                }}>
                    <div className={styles.itemTitleBox}>
                        <div className={classNames(styles.itemTitle, !item.readAt ? styles.noRead : '')}>{item.data?.title}</div>
                        <div className={styles.itemTime}>{item.createdAt}</div>
                    </div>
                    <div className={styles.itemContent}>{item.data?.content}</div>
                </div>
                
            </React.Fragment>
        );
    };

    render() {
        const { data, loading = false, hasMore = true, emptyText, emptyIcon, emptyBoxStyle, onLoadMore } = this.props;

        if (!Array.isArray(data)) return null;

        return (
            <div className={styles.listBox}>
                <InfiniteScrollList
                    variant="pc"
                    data={data}
                    loading={loading}
                    hasMore={hasMore}
                    onLoadMore={onLoadMore || (() => { })}
                    renderItem={this.renderItem}
                    threshold={100}
                    emptyText={emptyText || '这里是空的'}
                    emptyIcon={emptyIcon}
                    emptyBoxStyle={emptyBoxStyle}
                    loadingText="加载中..."
                    noMoreText="没有更多帖子了"
                />
            </div>
        );
    }
}

export default PCSystemList;